import React from 'react';
import ReactDOM from 'react-dom/client';
import { ModalStackProvider } from '@agendor/ui';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <React.StrictMode>
        <ModalStackProvider>
            <App />
        </ModalStackProvider>
    </React.StrictMode>,
);
